import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class RequestService {
    constructor(
        private http: HttpClient
    ) { }

    public Post<T>(url: string, value: any) {
        let currentUser = localStorage.getItem('currentUser');
        let options = {
            headers: {
                'Authorization': `Bearer ${currentUser}`,
            }
        };


        return this.http.post<T>(url, value, options);
    }
    public Get<T>(url: string) {
        let currentUser = localStorage.getItem('currentUser');
        let options = {
            headers: {
                'Authorization': `Bearer ${currentUser}`,
            }
        };

        return this.http.get<T>(url, options);
    }
    public DownloadFile(path: string) {
        let currentUser = localStorage.getItem('currentUser');
        let options = {
            responseType: 'blob' as 'json',
            header: {
                'Authorization': `Bearer ${currentUser}`,
            }
        };

        return this.http.get(path, options);
    }

    public DownloadFileByPost(path: string, value: any) {
        let currentUser = localStorage.getItem('currentUser');
        let options = {
            responseType: 'blob' as 'json',
            header: {
                'Authorization': `Bearer ${currentUser}`,
            }
        };

        return this.http.post(path, value, options);
    }

    public PostForm(path: string, value: any) {
        let options = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        };

        return this.http.post(path, value, options);
    }
}